import promotionRepository from './promotion.repository';
import { type CategoryRequestQuery } from '~/domains/category';

export default {
  async getActionById(id: string, params: CategoryRequestQuery) {
    return await promotionRepository.getActionById(id, params);
  },

  async getActionList() {
    return await promotionRepository.getActionList();
  },
};
